// PostOperativeCare.js
import React from 'react';
import { Link } from 'react-router-dom';
import PostOpHealingSection from '../components/PostOpHealingSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import RecoverSafelySection from '../components/RecoverSafelySection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const PostOperativeCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Post-Operative Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-bnCream pt-16 pb-16 md:pt-24 md:pb-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="flex items-center justify-center gap-2 text-sm text-bnBody mb-6">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="text-bnBorder">|</span>}
                {crumb.link ? (
                  <Link to={crumb.link} className="hover:text-bnAccent transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-bnInk">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
          <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Post-Operative Care
          </p>
          <h1 className="font-display font-light text-bnInk leading-[1.1] text-4xl md:text-5xl mb-5">
            Safe and Supportive Post-Operative Care at Home
          </h1>
          <p className="text-bnBody text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            Our carers help make recovery after surgery as smooth as possible, offering gentle support, medication reminders, and everyday assistance in the comfort of home.
          </p>
        </div>
      </section>
      <PostOpHealingSection />
      <ProudlyCaringSeniorsSection />
      <RecoverSafelySection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default PostOperativeCare;
